import FadeDiv from "./common/FadeDiv";
import React from "react";
import clsx from "clsx";

interface HighlightProps {
  title: string;
  description: string;
  points: string[];
  image: React.ReactNode;
  imageOnLeft?: boolean;
}

const Highlight: React.FC<HighlightProps> = ({
  title,
  description,
  points,
  image,
  imageOnLeft = true,
}) => {
  return (
    <FadeDiv
      className={clsx(
        "flex",
        "flex-col",
        "items-center",
        "md:flex-row",
        "md:max-h-[550px]",
        "h-auto",
        "bg-white",
        "border-y",
        "border-[#DADADA]",
        { "md:flex-row-reverse": imageOnLeft }
      )}
    >
      <div
        className={clsx(
          "w-full",
          "md:w-1/2",
          "h-[70vw]",
          "md:h-full",
          "bg-gray-200",
          "flex",
          "items-center",
          "justify-center",
          "[&>img]:object-cover",
          "[&>img]:h-full",
          "[&>img]:w-full"
        )}
      >
        {image}
      </div>
      <div
        className={clsx(
          "w-full",
          "md:h-full",
          "md:w-1/2",
          "py-4",
          "relative",
          "px-4",
          "md:px-6",
          "flex",
          "flex-col",
          "flex-grow"
        )}
      >
        <h2
          className={clsx(
            "text-[27px] md:text-[32px]",
            "font-medium",
            "mb-12",
            "text-gail-primary",
            "leading-6 md:leading-9",
            "md:mt-4",
            "max-w-sm md:max-w-md"
          )}
        >
          {title}
        </h2>
        <div
          className={clsx(
            "mb-6",
            "max-w-sm md:max-w-md",
            "mt-auto",
            "text-[17px] md:text-[21px] leading-7"
          )}
        >
          <p className={clsx("text-gray-600")}>{description}</p>
          <ul className={clsx("list-disc", "list-outside", "mt-6", "ml-6")}>
            {points.map((point, index) => (
              <li key={index} className={clsx("text-gray-600")}>
                {point}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </FadeDiv>
  );
};

export default Highlight;
